import * as actionTypes from './auth.types'

const initialState = {
  username: '',
  email: '',
  displayname: '',
  token: '',
  error: null,
  isLoading: false,
  redirectURL: '/'
};

const userReducer = (state = initialState, action) => {
  let updatedUser = null;
  switch (action.type) {
    case actionTypes.USER_SIGNIN_REQUEST:
      updatedUser = {
        ...state,
        isLoading: true
      };
      return updatedUser;
    case actionTypes.USER_SIGNIN_SUCCESS:
      updatedUser = {
        ...state,
        isLoading: false,
        username: action.userDets.user_nicename,
        email: action.userDets.user_email,
        displayname: action.userDets.user_display_name,
        token: action.token
      };
      return updatedUser;
    case actionTypes.USER_SIGNIN_ERROR:
      updatedUser = {
        ...state,
        isLoading: false,
        error: action.error
      };
      return updatedUser;
    case actionTypes.VALIDATE_TOKEN_SUCCESS:
      updatedUser = {
        ...state,
        token: action.token,
        email: action.email,
        redirectURL: action.redirectTo
      };
      return updatedUser;
    case actionTypes.VALIDATE_TOKEN_FAIL:
      updatedUser = {
        ...state,
        error: action.error
      };
      return updatedUser;
    case actionTypes.USER_SIGNOUT_REQUEST:
      updatedUser = {
        ...state,
        token: '',
        username: '',
        email: '',
        displayname: '',
        redirectURL: '/'
      };
      return updatedUser;
    default:
      return state;
  }
};

export default userReducer;
